import React, { useState, useEffect, useRef } from 'react'
import { useLayoutEffect } from 'components/common'

import s from './SearchBar.module.css'
import useDebounce from '../useDebounced'

const ProductSearch = ({
  pageOffset,
  searchedText,
  searchProduct,
  resetProductSearch
}) => {
  const [searchValue, setSearchValue] = useState('')
  const debouncedSearchValue = useDebounce(searchValue, 1000)

  const searchRef = useRef()

  useEffect(() => {
    setSearchValue(searchedText)
  }, [searchedText])

  useLayoutEffect(() => {
    if (pageOffset > 720) {
      searchRef.current.classList.add(s.productSearchWrapperTop)
    } else {
      searchRef.current.classList.remove(s.productSearchWrapperTop)
    }
  }, [pageOffset])

  useEffect(() => {
    if (debouncedSearchValue?.length >= 3) {
      searchProduct(debouncedSearchValue)
      window.scrollTo({ top: 300, behavior: 'smooth' })
    } else if (debouncedSearchValue === '') {
      resetProductSearch()
    }
  }, [debouncedSearchValue])

  return (
    <div ref={searchRef} className={s.productSearchWrapper}>
      <input
        className={s.searchInput}
        value={searchValue}
        placeholder="Search Product"
        onChange={(e) => setSearchValue(e.target.value)}
      />
    </div>
  )
}

export default ProductSearch
